import { phappsRequest } from './apiService';
import { buildMarketingPath } from '@/config/apiConstants';

const p = (path, params) => {
  const base = buildMarketingPath(path);
  if (!params) return base;
  const qs = new URLSearchParams(
    Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== '')
  ).toString();
  return qs ? `${base}?${qs}` : base;
};

export const getMarketingStaff = ()             => phappsRequest(p('staff'), 'GET');

export const getTodos   = ()         => phappsRequest(p('todos'), 'GET');
export const createTodo = (text)     => phappsRequest(p('todos'), 'POST', { text });
export const updateTodo = (id, body) => phappsRequest(p(`todos/${id}`), 'PUT', body);
export const deleteTodo = (id)       => phappsRequest(p(`todos/${id}`), 'DELETE');
export const getEntries       = (from, to)      => phappsRequest(p('entries', { from, to }), 'GET');
export const getEntry         = (id)            => phappsRequest(p(`entries/${id}`), 'GET');
export const createEntry      = (body)          => phappsRequest(p('entries'), 'POST', body);
export const updateEntry      = (id, body)      => phappsRequest(p(`entries/${id}`), 'PUT', body);
export const setEntryComplete = (id, completed) => phappsRequest(p(`entries/${id}/complete`), 'POST', { completed });
export const deleteEntry      = (id)            => phappsRequest(p(`entries/${id}`), 'DELETE');

export const getEntryComments = (id)            => phappsRequest(p(`entries/${id}/comments`), 'GET');
export const addEntryComment  = (id, comment)   => phappsRequest(p(`entries/${id}/comments`), 'POST', { comment });
export const deleteEntryComment = (commentId)   => phappsRequest(p(`comments/${commentId}`), 'DELETE');

export const deleteEntryAttachment = (attId)    => phappsRequest(p(`attachments/${attId}`), 'DELETE');

export const uploadEntryAttachment = async (id, file) => {
  const token = localStorage.getItem('jwtToken');
  const form = new FormData();
  form.append('file', file);
  const res = await fetch(`${import.meta.env.VITE_APP_DATA_API_URL}${buildMarketingPath(`entries/${id}/attachments`)}`, {
    method: 'POST',
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    body: form,
  });
  if (!res.ok) throw new Error((await res.json().catch(() => ({}))).message || 'Upload failed');
  return res.json();
};

export const downloadEntryAttachment = async (attId, filename) => {
  const token = localStorage.getItem('jwtToken');
  const res = await fetch(`${import.meta.env.VITE_APP_DATA_API_URL}${buildMarketingPath(`attachments/${attId}/download`)}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  if (!res.ok) throw new Error('Download failed');
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename || 'attachment';
  a.click();
  URL.revokeObjectURL(url);
};
